export function createWithdrawalRequestId() {
    if (window.crypto.randomUUID) return window.crypto.randomUUID();
    const bytes = window.crypto.getRandomValues(new Uint8Array(16));
    bytes[6] = (bytes[6] & 0x0f) | 0x40;
    bytes[8] = (bytes[8] & 0x3f) | 0x80;
    const hex = Array.from(bytes, value => value.toString(16).padStart(2, '0')).join('');
    return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}

export function buildWalletWithdrawalRequest(amount, accountInfo, payPassword, requestId, confirmationToken) {
    const body = { amount };
    if (accountInfo) {
        body.bank_cd = accountInfo.bankCd;
        body.bank_nm = accountInfo.bankName;
        body.accnt_no = accountInfo.account;
    }
    if (payPassword) body.pay_password = payPassword;
    if (requestId) body.request_id = requestId;
    if (confirmationToken) body.confirmation_token = confirmationToken;
    return body;
}
